export const API_RETRIES = 3;
export const PARAMETERS_RETRIES = 3;
export const FILE_RETRIES = 2;
export const DELAY_RETRIES = 1000; // milisenconds
